import { ParseObject } from './parse-object';

import * as _ from 'lodash';

import { Language } from './language';

export class Translatable extends ParseObject {
  public setTranslation(key: string, value: any, lang: string) {
    return super.set(key + '_' + lang, value);
  }

  public getTranslation(key: string, lang: string, defaultLang: boolean | string = true) {
    let v = super.get(key + '_' + lang);

    if (!v && defaultLang) {
      if (typeof defaultLang === "string") {
        v = super.get(key + '_' + defaultLang);
      } else {
        v = super.get(key + '_' + Language.DEFAULT_LANG);
      }
    }

    return v;
  }

  public addTranslation(key: string, item: any, lang: string) {
    return this.add(key + '_' + lang, item);
  }

  public addUniqeTranslation(key: string, item: any, lang: string) {
    return this.addUnique(key + '_' + lang, item);
  }

  public removeTranslation(key: string, item: any, lang: string) {
    return this.remove(key + '_' + lang, item);
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/translatable.ts